const paths: Record<string, string> = {
  home: 'M3 11.5 12 4l9 7.5V21h-6v-6H9v6H3z',
  partner: 'M12 3l2.8 5.7 6.2.9-4.5 4.4 1.1 6.2-5.6-3-5.6 3 1.1-6.2L3 9.6l6.2-.9z',
  live: 'M7 5h10v14H7z M3 9h2v6H3z M19 9h2v6h-2z',
  guide: 'M4 5h16v15H4z M4 9h16 M8 3v4 M16 3v4',
  movies: 'M4 6h16v14H4z M4 10h16 M8 6l2-3 M14 6l2-3',
  series: 'M5 7h14v11H5z M9 3l3 4 3-4',
  search: 'M11 4a7 7 0 1 0 0 14 7 7 0 0 0 0-14z M16 16l5 5',
  user: 'M12 12a4 4 0 1 0 0-8 4 4 0 0 0 0 8z M4 21a8 8 0 0 1 16 0',
  exit: 'M10 5H5v14h5 M14 8l4 4-4 4 M8 12h10',
  play: 'M8 5v14l11-7z',
  retry: 'M20 7v5h-5 M19 12a7 7 0 1 0-2 5',
  volume: 'M4 10v4h4l5 4V6L8 10z M16 9a4 4 0 0 1 0 6',
};

export function Icon({ name }: { name: keyof typeof paths }) {
  return (
    <svg className="icon" viewBox="0 0 24 24" aria-hidden="true">
      <path d={paths[name]} fill={name === 'play' ? 'currentColor' : 'none'} stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}
